import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <div className="mb-5 flex items-center gap-4">
    <span className="font-mono text-xs text-aqua">{index}</span>
    <span className="h-px w-10 bg-aqua/40" />
    <span className="eyebrow" data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</span>
  </div>
);
